<div>{{ 'selectDeselectServiceProvider.confirmationMessage.0' | translate }}</div>

<div *ngFor="let category of formValue.categories">
  <ng-container *ngIf="getConfirmationMessage(category) as msg">
    <div [innerHtml]="msg.key | translate: msg.params"></div>
  </ng-container>
</div>

<div class="pt-3">{{ 'selectDeselectServiceProvider.confirmationMessage.1' | translate }}</div>
<div class="pt-3">{{ 'selectDeselectServiceProvider.confirmationNote' | translate }}</div>
